import React from 'react'
import { IIconProps as IProps } from './IIconProps'

const IconBulletList = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      transform="translate(2.546 4.182)"
      fill={props.color}
      d="M0.686561 1.37817H1.54981C1.92843 1.37817 2.24142 1.06518 2.24142 0.686561C2.24142 0.307943 1.92843 0 1.54981 0H0.686561C0.312991 0 0 0.307943 0 0.686561C0 1.06518 0.312991 1.37817 0.686561 1.37817ZM3.88715 1.2974H10.2227C10.5609 1.2974 10.8285 1.02984 10.8285 0.686561C10.8285 0.348329 10.566 0.0807719 10.2227 0.0807719H3.88715C3.54891 0.0807719 3.28136 0.348329 3.28136 0.686561C3.28136 1.02479 3.54891 1.2974 3.88715 1.2974ZM0.686561 4.55856H1.54981C1.92843 4.55856 2.24142 4.25062 2.24142 3.872C2.24142 3.49338 1.92843 3.18544 1.54981 3.18544H0.686561C0.312991 3.18544 0 3.49338 0 3.872C0 4.25062 0.312991 4.55856 0.686561 4.55856ZM3.88715 4.47779H10.2227C10.5609 4.47779 10.8285 4.21528 10.8285 3.872C10.8285 3.53377 10.566 3.26621 10.2227 3.26621H3.88715C3.54891 3.26621 3.28136 3.53377 3.28136 3.872C3.28136 4.21023 3.54891 4.47779 3.88715 4.47779ZM0.686561 7.744H1.54981C1.92843 7.744 2.24142 7.43606 2.24142 7.05744C2.24142 6.67882 1.92843 6.37088 1.54981 6.37088H0.686561C0.312991 6.37088 0 6.67882 0 7.05744C0 7.43606 0.312991 7.744 0.686561 7.744ZM3.88715 7.66323H10.2227C10.5609 7.66323 10.8285 7.39568 10.8285 7.05744C10.8285 6.71921 10.566 6.45165 10.2227 6.45165H3.88715C3.54891 6.45165 3.28136 6.71416 3.28136 7.05744C3.28136 7.39568 3.54891 7.66323 3.88715 7.66323Z"
    />
  </svg>
)

export default IconBulletList
